export const ProviderMap = {
  flinks: 'Flinks',
  inverite: 'Inverite',
  finicity: 'Finicity',
};

export default ProviderMap;
